import { render } from "./ChatFooterBar.vue?vue&type=template&id=4e91faf9"
import script from "./ChatFooterBar.vue?vue&type=script&lang=js"
export * from "./ChatFooterBar.vue?vue&type=script&lang=js"

import "./ChatFooterBar.vue?vue&type=style&index=0&id=4e91faf9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chat/ChatFooterBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e91faf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e91faf9', __exports__)) {
    api.reload('4e91faf9', __exports__)
  }
  
  module.hot.accept("./ChatFooterBar.vue?vue&type=template&id=4e91faf9", () => {
    api.rerender('4e91faf9', render)
  })

}


export default __exports__